/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { isObject, isStringNotEmpty, objectHasPropertyString } from "utils/empty-exists";
import { useAuth } from "cms/auth/hooks/use-auth";
import { LinkSelectorWrapper } from "cms/links/link-selector/link-selector-wrapper";
// import { Logger } from "cms/utils/log/logger";

const Link = (props) => {

    const value = props?.value;
    const localState = props?.localState;
    const setLocalState = props?.setLocalState;
    const index = props?.index;
    const update = props.update;
    
    const { token } = useAuth();

    const [link, setLink] = useState();
    const [loadingLink, setLoadingLink] = useState(false);

    const loadLink = async () => {
        if (isStringNotEmpty(value)) {
            // Logger.debug(`loading link from DB: `, value)
            const _link = await SimpliCityAdminSDK.link.findOne(token, value);
            setLink(_link);
            return _link;
        }
    };

    useEffect(() => {
        const load = async () => {
            if (value) {
                await loadLink(value);
            }
        };
        // load once
        if (!isObject(link) || !objectHasPropertyString(link, "guid")) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleUpdate = (link) => {
        const newState = {
            ...localState,
            value: link?.guid,
        };
        setLocalState(newState);
        update(newState,index);
    };
    const onChangeLink = async (link) => {
        setLink(link);
        // Logger.debug(link)
        handleUpdate(link);
    };
    const onRemoveLink = async () => {
        setLink(undefined);
        handleUpdate("");
    };

    return (
        <>
            <LinkSelectorWrapper
                link={link}
                setLink={setLink}
                // linkGuid={link?.guid}
                // setLinkGuid={setLinkGuid}
                onLinkChange={(link) => onChangeLink(link)}
                onLinkRemove={() => onRemoveLink()}
                disabled={false}
                loadingLink={loadingLink}
                setLoadingLink={setLoadingLink}
            />
        </>
    );
};

export default Link;
